import { LocaleAuth } from '../en/auth'

const auth: LocaleAuth = {
  heading: '為了運動',
  signIn: '登入',
  forgotPass: '忘記密碼？',
  claimQuestion: '只是在錦標賽中？',
  claimAccount: '找回您的帳戶',
  claimAccountDesc: '已經參加過錦標賽或聯賽？ 您可能已經有一個個人檔案和一個DUPR等級。',
  noAccount: '沒有 DUPR 帳號？',
  signUp: '注册',
  createAccount: '創建帳戶',
  createPassword: '創建密碼',
  passInstructLength: '長度必須至少為6個字元',
  passInstructStructure: '必須包含一個或多個數位',
  forgotPassDesc: '輸入您的注册電子郵件，以接收如何重置密碼的說明。',
  checkYourEmail: '檢查你的電子郵件！',
  resetCodeSentGeneric: '如果該地址存在帳戶，我們已發送 4 位數程式碼。',
  verifyEmailDesc: '您剛剛獲得了一個通過電子郵件重置密碼的程式碼。 輸入4位數程式碼繼續。',
  verifyYourNumber: '驗證您的號碼',
  verifyPhoneNumberDesc: '一個4位數的程式碼已發送到您的電話號碼，請在此處輸入以進行驗證',
  claimAccountHelpText: '在蒐索欄中鍵入您的姓名，開始蒐索您的結果',
  notSeeYourself: '在這裡看不到自己？',
  lastMatch: '最後一場比賽',
  noMatchResult: '沒有比賽結果',
  accAlreadyTaken: '這個帳戶已經被使用了',
  accAlreadyTakenModal: '如果您認為這是您的帳號，但是被其他人使用了您的帳戶，請聯繫我們的諮詢團隊',
  iAgreeToThe: '我同意',
  termsOfService: '服務條款',
  privacyPolicy: '隱私政策',
  acceptTerms: '請接受服務條款以繼續',
  cookiePolicy: 'Cookie 政策',
}

export default auth
